import DeviceHelper, { Device} from '../Core/DeviceHelper';
var dominio = 'https://www.lanacion.com.ar';

var Sharing = {
    Initialize() {
        var $container = document.getElementsByClassName('header__titulo__share');
        if (!$container || $container.length === 0) return;
        var $buttonFB = document.getElementById('share-fb');
        var $buttonTW = document.getElementById('share-tw');
        var $buttonWSP = document.getElementById('share-wsp');

        $buttonFB.addEventListener('click', function (e) {
            e.preventDefault();
            shareFacebook();
        });

        $buttonTW.addEventListener('click', function (e) {
            e.preventDefault();

            var $button = e.target;
            var titulo = $button.getAttribute('data-title');
            shareTwitter(titulo);
        });

        $buttonWSP.addEventListener('click', function (e) {
            e.preventDefault();

            var $button = e.target;
            var titulo = $button.getAttribute('data-title');
            shareWhatsapp(titulo);
        });

        // Init FB
        FB && FB.init({
            appId: window.config.Statics.FacebookId,
            autoLogAppEvents: true,
            xfbml: true,
            version: 'v2.11'
        });
        FB && FB.AppEvents.logPageView();
    }
};

function isDesktop() {
    var device = DeviceHelper.GetDevice();
    return device == Device.Desktop;
}

function shareFacebook() {
    FB && FB.ui({
        method: 'share',
        mobile_iframe: true,
        href: `${dominio}${location.pathname}`
    }, function (response) { });
}

function shareTwitter(titulo) {
    var url = `//twitter.com/share?text=${titulo}&url=${dominio}${location.pathname}&via=LANACION`;
    openUrl(url);
}

function shareWhatsapp(titulo) {

    if (isDesktop()) {
        var urlShare = `https://api.whatsapp.com/send?text=${dominio}${location.pathname}`;
        open(urlShare, '_blank');
    } else {
        var _texto = titulo ? ': ' + titulo : '';
        var wspShare = `whatsapp://send?text=LANACION${_texto} - ${dominio}${location.pathname}`;
        location.href = wspShare;
    }

    // Analitics
    if (!window.dataLayer) {
        dataLayer.push({ 'event': 'shareItem', 'socialNetwork': 'WhatsApp' });
    }
}

function openUrl(url) {
    open(url, '', 'top=300,left=550,width=800,height=380');
}

export default Sharing;


// WEBPACK FOOTER //
// ./Statics/scripts/Modules/Sharing.js